import { useContext } from 'react';

import { web3CacheContext } from './Web3CacheProvider';

export const useWeb3Cache = () => {
  return useContext(web3CacheContext);
};
